/* eslint no-param-reassign: 0 */
import {
  validEndDate,
} from '@/dates';
import {
  cloneDeep,
} from 'lodash/fp';

import defaultAccomodationsFilter from '@/store-methods/defaultAccomodationsFilter';

export const changeFreeSearch = ($, value) => {
  $.accomodationsFilter.freeSearch = value;
};

export const changeRooms = ($, value) => {
  $.accomodationsFilter.bedrooms = value;
};

export const changeBeds = ($, value) => {
  $.accomodationsFilter.beds = value;
};

export const toggleDatepicker = ($) => {
  $.showDatepicker = !$.showDatepicker;
};

export const toggleFilters = ($, value) => {
  $.showFilters = value;
};

export const toggleMap = ($, value) => {
  $.showMap = value;
};

export const setFilterLocationId = ($, value) => {
  $.accomodationsFilter.locationId = value;
};

export const changeSorting = ($, payload) => {
  $.accomodationsFilter.sorting = payload.value;
};

export const toggleFilterSwitch = ($, payload) => {
  $.accomodationsFilter[payload.key] = payload.value;
};

export const toggleSkiSchoolFilterSwitch = ($, payload) => {
  // Only if setting age (not level)
  if (typeof payload === 'undefined' || parseInt(payload.key.substr(0, 1), 10) || payload.key === 'reset') {
    /*eslint-disable */
    for (var i in window.SITE_CONFIG.skischool.ages) {
      $.skiSchoolFilter[window.SITE_CONFIG.skischool.ages[i][1]] = false;
    }
    for (var i in window.SITE_CONFIG.skischool.levels) {
      $.skiSchoolFilter[i] = false;
    }

    $.skiSchoolFilter.date = null;
    /*eslint-enable */
  }

  if (payload && payload.key !== 'reset') {
    $.skiSchoolFilter[payload.key] = payload.value;
  }
};

export const toggleSkiSchoolFilterAgeSwitch = ($, payload) => {
  $.skiSchoolFilter.ages[payload.key] = payload.value;
};

export const toggleSkiSchoolSubFilter = ($, payload) => {
  $.skiSchoolFilter.childrenSub[payload.key] = payload.value;
};

export const resetAccomodationsFilter = ($, filter) => {
  if (filter) {
    $.accomodationsFilter[filter] = cloneDeep(defaultAccomodationsFilter[filter]);
  } else {
    /* eslint-disable */
    for (let index in $.accomodationsFilter) {
      const cloned = cloneDeep(defaultAccomodationsFilter[index]);
      if ($.cart.addToOrder && $.cart.addToOrder.number && index === 'date') {
      } else {
        $.accomodationsFilter[index] = cloned;
      }
    }
  }
  if (filter === 'date') {
    $.accomodationsFilter.availabelIds = [];
  }
};

export const resetSkiSchoolFilter = ($, filter) => {
  if (filter) {
    $.skiSchoolFilter[filter] = false;
  } else {
    /* eslint-disable */
    for (let index in $.skiSchoolFilter) {
      $.skiSchoolFilter[index] = false;
    }
  }
};

export const toggleSearch = ($, value) => {
  $.showSearch = value;
};

export const setAccomodationsFilterStartDate = ($, value) => {
  $.accomodationsFilter.date.startDate = value;
  if (
    !value
    || (
      $.accomodationsFilter.date.endDate
      && !validEndDate({
        startDate: $.accomodationsFilter.date.startDate,
      })($.accomodationsFilter.date.endDate)
    )
  ) {
    $.accomodationsFilter.date.endDate = null;
  }
};

export const setAccomodationsFilterEndDate = ($, value) => {
  $.accomodationsFilter.date.endDate = value;
};

export const setAccomodationsAvailableIds = ($, ids) => {
  $.accomodationsFilter.availabelIds = ids;
};

export default 'bar';



// WEBPACK FOOTER //
// ./src/store-methods/mutations/search.js